import {
  List,
  Text,
  TextLink,
  Table,
  TableRow,
  TableHeader,
  TableHeaderCell,
  TableBody,
  TableCell,
} from 'braid-design-system';

export const JobPostingFeatureList = () => (
  <Table label="Job Posting Scope">
    <TableHeader>
      <TableRow>
        <TableHeaderCell>
          <Text>Market</Text>
        </TableHeaderCell>
        <TableHeaderCell wrap>
          <Text>Features</Text>
        </TableHeaderCell>
        <TableHeaderCell wrap>
          <Text>Detail</Text>
        </TableHeaderCell>
      </TableRow>
    </TableHeader>
    <TableBody>
      <TableRow>
        <TableCell>
          <Text>ANZ</Text>
        </TableCell>
        <TableCell wrap>
          <Text>Ad Selection Revision</Text>
        </TableCell>
        <TableCell wrap>
          <List>
            <Text>
              <TextLink href="#locations">Dynamic Locations</TextLink>
            </Text>
            <Text>
              <TextLink href="#job-categories">Dynamic Job Categories</TextLink>
            </Text>
            <Text>
              <TextLink href="#ad-selection">Ad Selection - Panel</TextLink>
            </Text>
            <Text>
              <TextLink href="#ad-selection">Ad Selection - GraphQL</TextLink>
            </Text>
            <Text>
              <TextLink href="#questionnaires">Questionnaires</TextLink>
            </Text>
          </List>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell>
          <Text>ANZ</Text>
        </TableCell>
        <TableCell wrap>
          <Text>Job Ad Preview / Branding</Text>
        </TableCell>
        <TableCell wrap>
          <List>
            <Text>
              <TextLink href="#job-ad-preview">Job Ad Preview</TextLink>
            </Text>
            <Text>
              <TextLink href="#branding">Branding</TextLink> (Optional)
            </Text>
          </List>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell>
          <Text>Asia</Text>
        </TableCell>
        <TableCell wrap>
          <Text>Access to Asia features (Optional)</Text>
        </TableCell>
        <TableCell wrap>
          <List>
            <Text>
              <TextLink href="#salary">Salary Currencies</TextLink>
            </Text>
            <Text>
              <TextLink href="#salary">Monthly Salary</TextLink>
            </Text>
            <Text>
              <TextLink href="#content-localisation">
                Content Localisation
              </TextLink>{' '}
              (Language)
            </Text>
          </List>
        </TableCell>
      </TableRow>
    </TableBody>
  </Table>
);
